import {InjectionToken} from "@angular/core";
import {IIntAbstractListService} from "./types";

export const INT_ABSTRACT_LIST_API_REQUEST
  = new InjectionToken<IIntAbstractListService<unknown, unknown>>('INT_ABSTRACT_LIST_API_REQUEST');
